import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RulesComponent } from 'src/app/view/rules/rules.component';
import { RulesRegulationsComponent } from 'src/app/view/rules/rules-regulations/rules-regulations.component';
import { SchoolTimingComponent } from 'src/app/view/rules/school-timing/school-timing.component';
import { SchoolUniformComponent } from 'src/app/view/rules/school-uniform/school-uniform.component';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [
    RulesComponent,
    SchoolTimingComponent,
    RulesRegulationsComponent,
    SchoolUniformComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild([
      {path:'',component:RulesComponent, children:[
        {path:'school-timing',component:SchoolTimingComponent},
        {path:'rules-regulations',component:RulesRegulationsComponent},
        {path:'school-uniform',component:SchoolUniformComponent}
      ]}
    ]),
    SharedModule
  ]
})
export class RulesModule { }
